import { Messages } from "../../lib/locale";

export const Hungarian: Messages = {
  name: "Magyar",
  helpTitle: "Hogy játsszunk",
  help1: `Minden nap van egy új ország. A te dolgod, hogy a legkevesebb találgatással
  megtaláld ezt az országot. Minden hibás találgatás megjelenik a földgömbön.
  Az országok színe attól függ, hogy milyen messze vannak a kitalálandó országtól.
  Minél közelebb van az ország annál <b>melegebb</b> lesz a szín.`,
  help2: `Például ha <b>Japán</b> a kitalálandó ország akkor
  az alábbi országok ilyen szinekkel jelennek majd meg:`,
  help3: `Minden nap egy másik országot kell kitalálni!`,
  France: "Franciaország",
  Nepal: "Nepál",
  Mongolia: "Mongólia",
  "South Korea": "Dél-Korea",
  Aux1: `<b>["Kattincs", "Tap"]</b> a földgömbre!`,
  Aux2: "Van kérdésed?",
  Aux3: "Nézd meg a gyakori kérdéseket",
  Footer1: "The Abe Train által",
  Footer2: "Élvezed a játékot?",
  Footer3: "Hívj meg egy kávera",
  Loading: "Betöltés...",
  FAQTitle: "FAQ",
  q1: "1. How is the distance between the answer and my guess calculated?",
  a1: "Distance between countries is defined as the minimum distance between their land borders along the Earth's surface. Territories (areas that appear in gray when their parent country is guessed) and water borders are not included in distance calculations.",
  q2: "2. How can I play the game if I am colour blind or visually impaired?",
  a2: "A high-contrast Colour Blind mode can be activated in <button>Settings</button>.",
  q3: "3. How does the game decide what is a valid country?",
  a3: "Globle uses this <a>framework</a> to determine what constitutes a valid guess.",
  q4: "4. Are autonomous but not sovereign countries in the game?",
  a4: "Some territories will appear in a neutral colour when their sovereign country is guessed, e.g. Greenland for Denmark. The location of these territories does not impact the colour of the sovereign country. Most small territories do not appear in the game, e.g. Curaçao.",
  q5: "5. I found today's mystery country! When do I get to play again?",
  a5: "The mystery country changes and your guesses reset at midnight in your time zone.",
  q6: "6. Are alternative spellings for countries acceptable?",
  a6: "There are many countries with multiple acceptable names. Some alternate spellings and previous names are accepted, e.g. Burma for Myanmar. As well, acronyms are acceptable for some multi-word countries, e.g. UAE for United Arab Emirates.",
  q7: "7. A country is missing or a border is incorrect. What can I do about it?",
  a7: "Geography can be a sensitive topic, and some countries' borders are disputed. If you believe a correction should be made, please politely raise an issue on {GitHub} or DM me on {Twitter}.",
  GameTitle: "A játék",
  Game1: "Ide írd be az ország nevét",
  Game2: "Enter",
  Game3: "Írj be egy országnevet",
  Game4: `Húzd, <span>["kattincs", "tap"]</span>, nagyítsd meg a földgömböt hogy megtaláld a következő országot.`,
  Game5: "Hibás találgatás",
  Game6: "Ezt az országot már próbáltad",
  Game7: "A keresett ország {answer}!",
  Game8: "Legközelebbi határ:",
  StatsTitle: "Statisztika",
  Stats1: "Utolsó nyerés",
  Stats2: "Mai próbálkozások",
  Stats3: "Nyert játékok",
  Stats4: "Mostani sorozat",
  Stats5: "Legosszabb sorozat",
  Stats6: "Próbálkozások átlaga",
  Stats7: "Átlag próbálkozások",
  Stats8: "Újrakezdés",
  Stats9: "Megosztás",
  Stats10: "Biztos hogy törölni akarod a pontjaidat?",
  Stats11: "Statisztika törölve.",
  Stats12: "Vágólapba másolva!",
  SettingsTitle: "Beállítások",
  Settings1: "Nappali verzió",
  Settings2: "Éjszakai verzió",
  Settings3: "Színtévesztő mód be",
  Settings4: "Színtévesztő mód ki",
  Settings5: "Országok",
  Settings6: "Városok",
  Settings7: "Nyelv",
  Settings8: "Globle: A városok változat jön nemsokára!",
  Settings9: "Gyakorlás",
  Settings10: "Szivárvány be",
  Settings11: "Szivárvány ki",
  Answer: "Válasz",
  Closest: "Legközelebbi",
  PracticeMode: "Gyakorló üzemmódban vagy.",
  PracticeExit: "Lépj ki a gyakorló üzemmódból",
  PracticeNew: "Új gyakorló játék",
  Guessed: "sejtette",
  SortByGuesses: "Rendezés a találgatások sorrendje szerint",
  SortByDistance: "Rendezés távolság szerint",
};
